import styled from "styled-components";

export const TrainContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  /* max-width: 1440px; */
  padding: 0px 16px;
  flex: 1;
  padding-bottom: 20px;
`;

export const TrainGrid = styled.div`
  display: flex;
  flex-wrap: wrap;

  flex: 1;

  gap: 8px;
  @media (max-width: 768px) {
    gap: 4px;
  }

  @media (max-width: 480px) {
    justify-content: center;
  }
`;
export const PaginationWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding-top: 20px;
`;

export const Column = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  @media (max-width: 768px) {
    gap: 4px;
  }
`;

export const TrainModelCard = styled.div`
  border-radius: 24px;
  border: 1px solid #4d9dff;
  background: linear-gradient(180deg, #0f4e9e 0%, #072e61 100%);

  cursor: pointer;

  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;

  will-change: transform;
  backface-visibility: hidden;
  contain: layout style paint;

  display: flex;
  width: 100%;
  padding: 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  flex-shrink: 0;
  position: relative;
  aspect-ratio: 1 / 1.335;

  &:hover {
    box-shadow: 0 12px 32px rgba(40, 119, 217, 0.3);
  }

  svg {
    margin-bottom: -14px;
  }

  @media (max-width: 1440px) {
    svg {
      width: 100px;
      height: 100px;
    }
  }
  @media (max-width: 1023px) {
    svg {
      margin-bottom: -10px;
    }
    padding: 20px;
    gap: 20px;
  }

  @media (max-width: 599px) {
    svg {
      margin-bottom: -6px;
    }
    padding: 16px;
    gap: 16px;
    border-radius: 16px;
  }
`;

export const TrainGridContainer = styled.div`
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 599px) {
    padding: 0 16px;
  }
`;
export const Button = styled.button`
  display: flex;
  width: ${(props) => (props.$width ? "100%" : "180px")};
  height: 40px;
  padding: 12px 44px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: #fff;
  border: none;
  outline: none;

  color: #081120;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  /* justify-content: center; */
  padding: 28px 20px 60px 20px;
  text-align: center;
  flex: 1;

  h3 {
    font-size: 24px;
    margin-bottom: 12px;
    font-family: Figtree;
  }

  p {
    font-size: 16px;
    line-height: 1.5;
    max-width: 400px;
    font-family: Figtree;

    opacity: 0.6;
    margin-bottom: 24px;
  }
`;

export const CardIcon = styled.div`
  width: 64px;
  height: 64px;
  background: linear-gradient(135deg, #43e97b, #38f9d7);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #152a47;
  font-size: 24px;
  margin-bottom: 8px;
`;

export const CardTitle = styled.h3`
  color: #fff;
  text-align: center;
  font-family: Figtree;
  font-size: 24px;
  font-weight: 500;
  letter-spacing: -0.12px;

  span {
    display: inline-block;
    min-width: 16px;
    margin-left: 4px;
    text-align: left;
  }
`;

export const CardText = styled.span`
  font-family: Figtree;
  color: #fff;
  text-align: center;
  opacity: 0.78;
  font-size: 14px;
  font-weight: 400;
`;

export const CardLink = styled.span`
  font-family: Figtree;
  text-align: center;

  color: #b3d4ff;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  line-height: 22px; /* 157.143% */
  text-decoration-line: underline;
`;
export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
`;
export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  gap: 8px;
`;

export const CardDescription = styled.p`
  font-size: 14px;
  line-height: 1.5;
  margin: 0;
  color: ${({ theme }) =>
    theme === "light" ? "rgba(0, 0, 0, 0.6)" : "rgba(255, 255, 255, 0.7)"};
`;
export const IconContainer = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
`;
export const ModelCard = styled.div`
  display: flex;
  width: 100%;
  padding: 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  position: relative;
  aspect-ratio: 1 / 1.335;

  border-radius: 24px;
  border: 0.5px solid #325682;
  background: #142743;
  cursor: pointer;

  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 12px 32px #32568250;
  }

  h3 {
    animation: preparing-pulse-text 2s ease-in-out infinite;
  }

  @keyframes preparing-pulse-text {
    0%,
    100% {
      transform: scale(1);
      opacity: 1;
    }
    50% {
      transform: scale(0.985);
      opacity: 0.8;
    }
  }

  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;

  will-change: transform;
  backface-visibility: hidden;
  contain: layout style paint;

  @media (max-width: 1023px) {
    padding: 20px;
    gap: 20px;
  }

  @media (max-width: 599px) {
    padding: 16px;
    gap: 16px;
    border-radius: 16px;
  }
`;

export const ModelIcon = styled.div`
  width: 48px;
  height: 48px;
  background: ${({ theme }) =>
    theme === "light" ? "rgba(0, 0, 0, 0.1)" : "rgba(255, 255, 255, 0.1)"};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2877d9;
  font-size: 18px;
  margin-bottom: 8px;
`;

export const ModelTitle = styled.h4`
  position: absolute;
  left: 16px;
  bottom: 16px;

  color: #fff;
  font-family: Figtree;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: -0.09px;
`;

export const ModelStatus = styled.div`
  margin-top: 8px;
`;

export const ModelStatusText = styled.span`
  background: ${({ theme }) =>
    theme === "light" ? "rgba(255, 193, 7, 0.2)" : "rgba(255, 193, 7, 0.3)"};
  color: ${({ theme }) => (theme === "light" ? "#b8860b" : "#ffc107")};
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const BannerContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  padding: 16px;
  gap: 16px;

  margin-bottom: 16px;

  border-radius: 16px;
  border: 0.5px solid #760ea2;
  background: linear-gradient(270deg, #a341e4 0%, #24073d 100%);

  flex-wrap: wrap;
  @media (max-width: 768px) {
    align-items: center;
    justify-content: center;
  }
`;

export const BannerTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
export const BannerRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  flex-wrap: wrap;
`;
export const BannerColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
export const BannerList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-left: 24px;
`;
export const BannerListItem = styled.li`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 400;
  opacity: 0.8;
  line-height: 20px; /* 142.857% */
  letter-spacing: -0.21px;
`;

export const BannerTitle = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.24px;
`;
export const BannerSubtitle = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: -0.225px;
`;

export const BannerText = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: -0.21px;
`;

export const BannerButton = styled.button`
  display: flex;
  height: 40px;
  padding: 9px 24px;
  justify-content: center;
  align-items: center;
  gap: 10px;

  border-radius: 100px;
  border: 1px solid #2877d9;
  background: #fff;
  cursor: pointer;
  outline: none;

  transition: all 0.3s ease-in-out;

  color: #000;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 600;
  line-height: 150%; /* 21px */
  letter-spacing: 0.07px;

  &:hover {
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0px);
    background: #fff9;
  }

  &:disabled {
    cursor: not-allowed;
    transform: none !important;
    background: #fff;
  }
`;
